import { AddpaymentsComponent } from './addpayments/addpayments.component';
import { ViewpaymenthistoryComponent } from './viewpaymenthistory/viewpaymenthistory.component';

export const PaymentHistoryDeclaration = [
    AddpaymentsComponent, ViewpaymenthistoryComponent
];
